// SEQ=10124 P8-CK-H — Diplomat UX 오버레이
// 사양: SEQ-10119 §3-3 #3 + SEQ-10123 §1-2 #3
//   ── 미연결 도로만 제거 가능 (OWNER ≠ NULL + 양끝 vertex 인접 점유자 없음)
//   ── 클라 사전 집계: candidateEdgeIds (보드 highlight + 클릭 dispatch 검증)
//   ── 서버 검증 follow-up: SP 본문에서 OWNER NULL + 양끝 vertex 인접 점유 부재 재검증
//      (현 STEP=2에서는 명세 동결, SP 본문 보강은 별도 SEQ)
//
// 본 오버레이는 안내 배지 + 후보 개수 + 취소만 담당. 클릭 처리는 Play.tsx.
export interface DiplomatRoadOverlayProps {
  /** 본인 외 사용자 도로 중 미연결 후보 edge 집합 */
  candidateEdgeIds: number[]
  /** 취소 → ActionMode rollback */
  onCancel: () => void
}

export default function DiplomatRoadOverlay({
  candidateEdgeIds, onCancel,
}: DiplomatRoadOverlayProps) {
  return (
    <div style={overlay}>
      <div style={card}>
        <div style={title}>🤝 외교관 (Diplomat)</div>
        <div style={body}>
          <div>제거할 <b>미연결 도로(상대 1개)</b>를 클릭하세요.</div>
          <div style={hint}>후보 edge {candidateEdgeIds.length}개 (양끝 vertex 미점유 도로).</div>
          {candidateEdgeIds.length === 0 && (
            <div style={warn}>제거 가능한 도로가 없습니다. 취소하거나 다른 카드를 사용하세요.</div>
          )}
        </div>
        <div style={footer}>
          <button onClick={onCancel} style={btnSec}>취소</button>
        </div>
      </div>
    </div>
  )
}

const overlay: React.CSSProperties = {
  position: 'fixed', top: 12, right: 12, zIndex: 950, pointerEvents: 'none',
}
const card: React.CSSProperties = {
  background: '#fff', border: '1px solid #888', borderRadius: 6, padding: 12,
  minWidth: 240, boxShadow: '0 2px 8px rgba(0,0,0,0.2)', pointerEvents: 'auto',
}
const title:  React.CSSProperties = { fontWeight: 'bold', marginBottom: 6, fontSize: 14 }
const body:   React.CSSProperties = { fontSize: 12 }
const hint:   React.CSSProperties = { fontSize: 11, color: '#666', marginTop: 4 }
const warn:   React.CSSProperties = { fontSize: 11, color: '#c00', marginTop: 4 }
const footer: React.CSSProperties = { marginTop: 8, textAlign: 'right' }
const btnSec: React.CSSProperties = { padding: '4px 10px', background: '#eee', border: '1px solid #aaa', borderRadius: 3, cursor: 'pointer' }
